// We want to get rid of all the facades files. We only need them to make testing easier so in this case we should
// export top level elements from this file.
export const getWindow = () => global;
export const getDocument = () => global.document;
export const getAJS = () => global.AJS;
export const getConfluence = () => global.Confluence;
